import { gql } from '@apollo/client';

export const GROUP_CALL_FRAGMENT = gql`
  fragment GroupCallFragment on GroupCall {
    __typename
    _id
    trainerId
    title
    desc
    recurrence
    dayOfMonth
    startTime
    endTime
    timezone
    meetingUrl
    calendarId
    calendarSequence
    rescheduledAt
    rescheduledByUserId
    canceledAt
    status
    access
    createdAt
    updatedAt
  }
`;

export const GET_GROUP_CALLS = gql`
  query GetGroupCalls($input: GroupCallsQueryInput) {
    groupCalls(input: $input) {
      ...GroupCallFragment
    }
  }
  ${GROUP_CALL_FRAGMENT}
`;

export const GET_GROUP_CALL = gql`
  query GetGroupCall($id: ID!) {
    groupCall(id: $id) {
      ...GroupCallFragment
    }
  }
  ${GROUP_CALL_FRAGMENT}
`;

export const CREATE_GROUP_CALL = gql`
  mutation CreateGroupCall($input: GroupCallInput!) {
    createGroupCall(input: $input) {
      ...GroupCallFragment
    }
  }
  ${GROUP_CALL_FRAGMENT}
`;

export const UPDATE_GROUP_CALL = gql`
  mutation UpdateGroupCall($id: ID!, $input: GroupCallInput!) {
    updateGroupCall(id: $id, input: $input) {
      ...GroupCallFragment
    }
  }
  ${GROUP_CALL_FRAGMENT}
`;

export const DELETE_GROUP_CALL = gql`
  mutation DeleteGroupCall($id: ID!) {
    deleteGroupCall(id: $id) {
      message
      status
      id
    }
  }
`;
